import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

function PrivacyPolicy() {
  return (
    <div>
      <Nav />
      <div className='wrapper-container legal-container'>
        <div className='wrapper-content'>

          <div className='title-wrapper'>
            <h2>Politique de confidentialité</h2>
          </div>

          <p>
            La présente politique explique comment Fastline collecte et utilise les données personnelles des utilisateurs.
          </p>

          <br />

          <h2><strong>1. Données collectées</strong></h2>
          <p>
            Dans le cadre de l’utilisation de la plateforme, Fastline peut collecter les données suivantes :
          </p>

          <ul>
            <li>nom et prénom</li>
            <li>adresse email</li>
            <li>numéro de téléphone</li>
            <li>adresse de livraison</li>
            <li>historique de commandes</li>
            <li>données techniques (adresse IP, navigation)</li>
          </ul>

          <p>
            Fastline ne stocke pas les données bancaires des utilisateurs.
          </p>

          <br />

          <h2><strong>2. Comptes vendeurs</strong></h2>
          <p>
            Les vendeurs doivent fournir des informations d’identification, notamment leur identité,
            leurs coordonnées et les informations relatives à leur activité professionnelle.
          </p>

          <br />

          <h2><strong>3. Utilisation des données</strong></h2>
          <p>
            Les données sont utilisées pour :
          </p>

          <ul>
            <li>la gestion des comptes</li>
            <li>le traitement des commandes</li>
            <li>la communication entre clients et vendeurs</li>
            <li>le support utilisateur</li>
            <li>l’amélioration du service</li>
          </ul>

          <br />

          <h2><strong>4. Paiement</strong></h2>
          <p>
            Les paiements sont traités via Stripe.
          </p>
          <p>
            Les données bancaires sont collectées et traitées directement par Stripe.
            Fastline n’a pas accès à ces informations.
          </p>

          <br />

          <h2><strong>5. Destinataires des données</strong></h2>
          <p>
            Les données peuvent être transmises uniquement aux acteurs nécessaires au fonctionnement du service :
          </p>

          <ul>
            <li>les vendeurs (pour le traitement des commandes)</li>
            <li>Stripe (paiement sécurisé)</li>
            <li>Firebase / Google (hébergement et infrastructure)</li>
            <li>Google Analytics et Meta (mesure d’audience et performance)</li>
          </ul>

          <p>
            Aucune donnée n’est vendue à des tiers.
          </p>

          <br />

          <h2><strong>6. Durée de conservation</strong></h2>
          <p>
            Les données sont conservées pendant une durée maximale de 3 ans après la dernière activité de l’utilisateur.
          </p>

          <br />

          <h2><strong>7. Sécurité</strong></h2>
          <p>
            Fastline met en œuvre des mesures techniques et organisationnelles pour protéger les données.
          </p>

          <br />

          <h2><strong>8. Droits des utilisateurs</strong></h2>
          <p>
            Conformément au RGPD, vous disposez des droits suivants :
          </p>

          <ul>
            <li>droit d’accès</li>
            <li>droit de rectification</li>
            <li>droit de suppression</li>
            <li>droit d’opposition</li>
          </ul>

          <p>
            Vous pouvez exercer ces droits en contactant :
            <a href="mailto:contact@fastlineapp.com"> contact@fastlineapp.com</a>
          </p>

          <br />

          <h2><strong>9. Mineurs</strong></h2>
          <p>
            La plateforme est accessible aux mineurs sous la responsabilité de leurs représentants légaux.
          </p>

          <br />

          <h2><strong>10. Cookies</strong></h2>
          <p>
            Fastline utilise des cookies et traceurs. Pour en savoir plus, consultez la{" "}
            <Link to="/cookie-policy" style={{textDecoration:'underline'}}>Politique de cookies</Link>.
          </p>

          <br />

          <h2><strong>11. Droit applicable</strong></h2>
          <p>
            La présente politique est soumise au droit français.
          </p>

        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;